/*
 * "Email me when it's back" for an out-of-stock A4 sample. One dialog per page
 * (snippets/vmcm-restock.liquid) fed by any [data-restock-open] control: the
 * finish page link, the sample box swatch, the size sheet link. The dialog's form
 * is Shopify's own customer form, so this script only sets the finish tag
 * (restock-<handle>) before the native post and shows the confirmation when
 * Shopify redirects back with customer_posted=true. No dialog means no work here.
 */
(function (global) {
  "use strict";

  var doc = global.document;
  var dialog = doc.querySelector("[data-restock-dialog]");
  if (!dialog) return;

  var form = dialog.querySelector("[data-restock-form]");
  var done = dialog.querySelector("[data-restock-done]");
  var finishEl = dialog.querySelector("[data-restock-finish]");
  var tagEl = dialog.querySelector("[data-restock-tag]");
  var emailEl = dialog.querySelector("[data-restock-email]");
  var errorEl = dialog.querySelector("[data-restock-error]");
  var eyebrowEl = dialog.querySelector("[data-restock-eyebrow]");
  var titleEl = dialog.querySelector("[data-restock-title]");
  var privacyEl = dialog.querySelector("[data-restock-privacy]");
  var doneTextEl = dialog.querySelector("[data-restock-donetext]");
  var SAMPLE = {
    title: titleEl ? titleEl.textContent : "",
    privacy: privacyEl ? privacyEl.textContent : "",
    done: doneTextEl ? doneTextEl.textContent : ""
  };
  var lastTrigger = null;
  var KEY = "vmcm-restock-finish";

  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function show(el, on) { if (el) el.hidden = !on; }
  function setError(text) { if (errorEl) errorEl.textContent = text || ""; }
  function remember(value) { try { global.sessionStorage.setItem(KEY, JSON.stringify(value)); } catch (e) { /* private mode */ } }
  function recall() { try { return JSON.parse(global.sessionStorage.getItem(KEY)) || null; } catch (e) { return null; } }
  function forget() { try { global.sessionStorage.removeItem(KEY); } catch (e) { /* private mode */ } }

  // Sample alerts keep the sample wording; a roll alert names the finish it was opened from.
  function setCopy(finish, kind) {
    var roll = kind === "roll" && finish;
    var news = " You'll also get the occasional Velven news. Unsubscribe any time from any email.";
    if (eyebrowEl) { eyebrowEl.hidden = !!roll; eyebrowEl.style.display = roll ? "none" : ""; }
    if (titleEl) titleEl.textContent = roll ? "Email me when " + finish + " is back in stock" : SAMPLE.title;
    if (finishEl) { finishEl.hidden = !!roll; finishEl.style.display = roll ? "none" : ""; finishEl.textContent = roll ? "" : (finish ? finish + " A4 sample" : ""); }
    if (privacyEl) privacyEl.textContent = roll ? "We'll email you when " + finish + " is back in stock." + news : SAMPLE.privacy;
    if (doneTextEl) doneTextEl.textContent = roll ? "We'll do our best to let you know when " + finish + " is back." + news : SAMPLE.done;
  }

  function setTag(handle, kind) {
    tagEl.value = (kind === "roll" ? "rollalert-" : "restock-") + handle;
  }

  function present() {
    if (typeof dialog.showModal === "function") { if (!dialog.open) dialog.showModal(); }
    else dialog.setAttribute("open", "");
  }

  function open(trigger) {
    var handle = trigger.getAttribute("data-restock-handle") || trigger.getAttribute("data-handle") || "";
    var finish = trigger.getAttribute("data-restock-finish") || trigger.getAttribute("data-finish") || "";
    if (!handle) return;
    // The size sheet is itself a modal; close it so this dialog is the only one up.
    var sheet = doc.querySelector("[data-selection-sheet][open]");
    if (sheet && typeof sheet.close === "function") sheet.close();
    lastTrigger = trigger;
    var kind = trigger.getAttribute("data-restock-kind") || "";
    setTag(handle, kind);
    remember({ handle: handle, finish: finish, kind: kind });
    setCopy(finish, kind);
    setError("");
    show(form, true);
    show(done, false);
    present();
    emailEl.focus();
  }

  function close() {
    if (typeof dialog.close === "function") dialog.close();
    else dialog.removeAttribute("open");
    if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
  }

  // Native post, so Shopify's own spam check can run; only an obviously bad address is stopped here.
  form.addEventListener("submit", function (event) {
    var email = (emailEl.value || "").trim();
    if (!tagEl.value || !EMAIL.test(email) || email.length > 254) {
      event.preventDefault();
      setError("Enter a valid email address.");
      emailEl.focus();
    }
  });

  doc.addEventListener("click", function (e) {
    var closer = e.target.closest("[data-restock-close]");
    if (closer && dialog.contains(closer)) { close(); return; }
    if (e.target === dialog) { close(); return; }
    var trigger = e.target.closest("[data-restock-open]");
    if (!trigger) return;
    e.preventDefault();
    open(trigger);
  });

  var query = global.location ? global.location.search : "";
  var pending = recall();
  if (/[?&]customer_posted=true(?:&|$)/.test(query) && pending && pending.handle) {
    // Shopify redirected back after a successful post: confirm, then tidy the address bar.
    forget();
    setTag(pending.handle, pending.kind);
    setCopy(pending.finish, pending.kind);
    show(form, false);
    show(done, true);
    present();
    if (done.focus) done.focus();
    if (global.history && global.history.replaceState) global.history.replaceState(null, "", global.location.pathname);
  } else if (errorEl && errorEl.textContent.trim()) {
    // Shopify re-rendered the page with a form error: reopen on the form.
    if (pending && pending.handle) {
      setTag(pending.handle, pending.kind);
      setCopy(pending.finish, pending.kind);
    }
    present();
  } else if (global.location && (global.location.hash === "#vmcm-restock" || global.location.hash === "#vmcm-restock-roll")) {
    var auto = doc.querySelector(global.location.hash + "[data-restock-open]");
    if (auto) open(auto);
  }
})(window);
